import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import {
  initialPlaybackSession,
  playbackSessionReducer,
  supportsPictureInPicture,
} from '../lib/playbackSession';

const PlaybackSessionContext = createContext(null);

const PlaybackSessionProvider = ({ children }) => {
  const [session, dispatch] = useReducer(playbackSessionReducer, initialPlaybackSession);

  const startSession = useCallback((payload) => dispatch({ type: 'START', payload }), []);
  const syncSession = useCallback((payload) => dispatch({ type: 'SYNC', payload }), []);
  const transferOwner = useCallback((payload) => dispatch({ type: 'TRANSFER', payload }), []);
  const updateRoute = useCallback((route) => dispatch({ type: 'ROUTE', payload: { route } }), []);
  const endSession = useCallback(() => dispatch({ type: 'END' }), []);

  const value = useMemo(() => ({
    session,
    startSession,
    syncSession,
    transferOwner,
    updateRoute,
    endSession,
    pictureInPictureSupported: supportsPictureInPicture(),
  }), [endSession, session, startSession, syncSession, transferOwner, updateRoute]);

  return <PlaybackSessionContext.Provider value={value}>{children}</PlaybackSessionContext.Provider>;
};

const usePlaybackSession = () => {
  const context = useContext(PlaybackSessionContext);
  if (!context) throw new Error('usePlaybackSession must be used within PlaybackSessionProvider');
  return context;
};

export { PlaybackSessionProvider, usePlaybackSession };
export default PlaybackSessionContext;
